<section>
  <ng-container *ngIf="stateLocalAdmins.length">
    <h2 class="h5 mb-2">State and Local LE Application Administrators:</h2>
    <ul class="list-unstyled font-size-sm mb-4 ms-3">
      <li *ngFor="let user of stateLocalAdmins">
        {{user.FirstName}} {{user.LastName}} ({{user.Email}})
      </li>
    </ul>
  </ng-container>
  <ng-container *ngIf="stateLocalPowerUsers.length">
    <h2 class="h5 mb-2">State and Local LE Power Users:</h2>
    <ul class="list-unstyled font-size-sm mb-4 ms-3">
      <li *ngFor="let user of stateLocalPowerUsers">
        {{user.FirstName}} {{user.LastName}} ({{user.Email}})
      </li>
    </ul>
  </ng-container>
  <ng-container *ngIf="fdAdmins.length">
    <h2 class="h5 mb-2">Field Division Application Administrators:</h2>
    <ul class="list-unstyled font-size-sm mb-4 ms-3">
      <li *ngFor="let user of fdAdmins">
        {{user.FirstName}} {{user.LastName}} ({{user.Email}})
      </li>
    </ul>
  </ng-container>
  <ng-container *ngIf="fdPowerUsers.length">
    <h2 class="h5 mb-2">Field Division Power Users:</h2>
    <ul class="list-unstyled font-size-sm mb-4 ms-3">
      <li *ngFor="let user of fdPowerUsers">
        {{user.FirstName}} {{user.LastName}} ({{user.Email}})
      </li>
    </ul>
  </ng-container>
  <ng-container *ngIf="hqAdmins.length">
    <h2 class="h5 mb-2">ATF HQ Application Administrators:</h2>
    <ul class="list-unstyled font-size-sm mb-4 ms-3">
      <li *ngFor="let user of hqAdmins">
        {{user.FirstName}} {{user.LastName}} ({{user.Email}})
      </li>
    </ul>
  </ng-container>
  <ng-container *ngIf="hqPowerUsers.length">
    <h2 class="h5 mb-2">ATF HQ Power Users:</h2>
    <ul class="list-unstyled font-size-sm mb-4 ms-3">
      <li *ngFor="let user of hqPowerUsers">
        {{user.FirstName}} {{user.LastName}} ({{user.Email}})
      </li>
    </ul>
  </ng-container>
</section>
